import {JobWatcherChangeNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * Job watcher change notification class data.
 */
export default class JobWatcherChangeNotificationData {
	/**
	 *
	 * @param {string} jobId
	 * @param {string} creator
	 * @param {string[]} previousWatchersIds
	 * @param {string[]} currentWatchersIds
	 * @param {string} referenceNumber
	 */
	constructor(readonly jobId: string,
		readonly creator: AuthenticatedEntity,
		readonly previousWatchersIds: string[],
		readonly currentWatchersIds: string[],
		readonly referenceNumber: string) {}

	static fromJson(json: JobWatcherChangeNotificationDataApiDto): JobWatcherChangeNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new JobWatcherChangeNotificationData(json.jobId, creator, json.previousWatchers, json.currentWatchers,
			json.referenceNumber);
	}

	getJobReferenceNumber() {
		return this.referenceNumber;
	}
}
